import { styled, TextareaAutosize } from '@mui/material';

const StyledTextareaAutosize = styled(TextareaAutosize)`
  textarea {
    font-size: 10px;
    background-color: #fcfcfc;
  }
`;

export default StyledTextareaAutosize;
